// Libraries
import { useTranslation } from 'react-i18next';

// MUI
// Core
// Common
// Interfaces
import { Box, Grid, Link, Typography } from '@mui/material';
import { IEvent } from '../../interfaces/IEvent';

// Store
// API
// Messaging
// Feature - Event

interface IEventMeetingLinkProps {
    meetingLink: string;
}

export default function EventMeetingLink({ meetingLink }: IEventMeetingLinkProps) {
    const { t } = useTranslation(['AnelmaEvents']);

    const boxDataRobotId = `online-event-${t('AnelmaEvents:1008')}`;

    return (
        <Box sx={{ margin: '10px 0' }} data-robot-id={boxDataRobotId}>
            <Typography variant='h5'>{t('AnelmaEvents:1008')}</Typography>
            <Link href={meetingLink} target='_blank' rel='noreferrer'>
                {t('AnelmaEvents:1057')}
            </Link>
        </Box>
    );
}
